import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const CapTitle = styled('div')`
  width: 437px;
  height: 44px;
  font-size: var(--ph-heading-one);
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--black);
  margin: 0 0 40px 0;
`;

const CapSortingDiv = styled('div')`
  margin: 0 0 40px 0;
  object-fit: contain;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.86;
  letter-spacing: normal;
  color: var(--ph-gray-500);
`;

const ButtonSpan = styled('span')`
  object-fit: contain;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.86;
  letter-spacing: normal;
  color: var(--ph-gray-500);
  height: 26px;
  border-radius: var(--ph-border-radius-sm);
  background-color: #f2f2f2;
  padding: 6px 14px;
  margin: 0 6px;

  &.firstBottonMargin {
    margin-left: 9px;
  }

  &.selected {
    background-color: var(--ph-gray-700);
    color: var(--white);
  }

  &:hover {
    cursor: pointer;
  }
`;

const CapBoxDiv = styled('div')`
  & + & {
    margin-top: 20px;
  }
`;

const Left = styled('div')`
  padding: 25px;
  margin-right: 50px;
  background-color: var(--white);
  border-right: 1px solid rgba(var(--black), 0.1);
  height: 100%;
`;

const Right = styled('div')`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 50px;
  padding: 25px 10px 10px 12px;
  background-color: rgba(var(--ph-gray-rgb-50), 0.2);
`;

const CollapsedBtn = styled('div')`
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  background-color: var(--grey-btn);
  border-radius: var(--ph-border-radius-sm);
  padding: 10px 3px 10px 5px;
  writing-mode: vertical-lr;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--ph-gray-700);
  transform: rotate(180deg);

  &.lang-cn {
    transform: rotate(0deg);
  }
`;

const Wrapper = styled('div')`
  position: relative;
  overflow-x: hidden;
`;

const InfoOverlay = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  width: 50%;
  background-color: var(--white);
  padding: 30px 0;
  border: solid 1px #e4e4e4;
  transition: right 0.3s;
  z-index: 9999;

  &::before {
    display: block;
    content: '';
    position: absolute;
    right: 100%;
    top: -1px;
    bottom: -1px;
    width: 80px;
    opacity: 0.1;
    background-image:
      linear-gradient(
        to right,
        rgba(0, 0, 0, 0) 0%,
        var(--ph-gray-500) 100%
      );
  }

  &.hidden {
    right: -100%;
    visibility: hidden;
  }
`;

const CloseBtn = styled(Svg)`
  width: 15px;
  height: 15px;
  cursor: pointer;
  position: absolute;
  top: 39px;
  right: 40px;

  path {
    fill: var(--dark-grey);
  }
`;

const FeedbackHistoryText = styled('div')`
  position: absolute;
  top: 39px;
  font-size: var(--ph-heading-two);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--black);
  padding: 0 40px;
`;

const HistoryDiv = styled('div')`
  position: relative;
  top: 55px;
`;

const HistoryRow = styled('div')`
  display: flex;
  padding: 12px 40px;
`;

const ActivityColumn = styled('div')`
  flex: 5;
  align-items: center;
  display: flex;

  &.title {
    font-size: var(--ph-text-sm);
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.69;
    letter-spacing: normal;
    color: var(--ph-gray-700);
  }
`;
const IdColumn = styled('div')`
  flex: 1;
  align-items: center;
  display: flex;

  &.title {
    font-size: var(--ph-text-sm);
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.69;
    letter-spacing: normal;
    color: var(--ph-gray-700);
  }
`;
const SubmittedOnColumn = styled('div')`
  flex: 2;
  align-items: center;
  display: flex;

  &.title {
    font-size: var(--ph-text-sm);
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.69;
    letter-spacing: normal;
    color: var(--ph-gray-700);
  }
`;
const SubmittedByColumn = styled('div')`
  flex: 3;
  justify-content: center;
  align-items: center;
  display: flex;

  &.title {
    font-size: var(--ph-text-sm);
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.69;
    letter-spacing: normal;
    color: var(--ph-gray-700);
  }
`;

const HistoryLine = styled('div')`
  width: 100%;
  height: 1px;
  opacity: 0.3;
  border-top: solid 1px var(--ph-gray-500);
  margin-bottom: 20px;
`;

const ExternalCAPUsersWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
`;

const Table = styled('table')`
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--white);
  width: 100%;
  font-size: var(--ph-text-sm);
  box-shadow: var(--ph-box-shadow-sm);
  border-collapse: collapse;
  margin-bottom: 40px;

  thead {
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-gray-100);
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: var(--white);
    padding: 0 10px;
  }

  td {
    border: 0;
    padding: 5px 10px;
  }
`;

const CapOverallStatus = styled('div')`
  display: flex;
  margin: 0 0 40px 0;
  object-fit: contain;
  font-size: var(--ph-text-sm);
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.86;
  letter-spacing: normal;
`;

const CapTabActionRow = styled('div')`
  position: absolute;
  top: 3.5rem;
  right: 7rem;
`;

const Block = styled('div')`
  margin-bottom: 20px;

  &.flex {
    display: flex;
  }
`;

const Half = styled('div')`
  width: 50%;

  div[class*='Field'] {
    margin-bottom: 15px;
  }
`;

export default {
  ActivityColumn,
  ButtonSpan,
  CapBoxDiv,
  CapSortingDiv,
  CapTabActionRow,
  CapTitle,
  CloseBtn,
  CollapsedBtn,
  ExternalCAPUsersWrapper,
  FeedbackHistoryText,
  HistoryDiv,
  HistoryLine,
  HistoryRow,
  IdColumn,
  InfoOverlay,
  Left,
  Right,
  SubmittedByColumn,
  SubmittedOnColumn,
  Table,
  Wrapper,
  CapOverallStatus,
  Block,
  Half
};
